import { render, staticRenderFns } from "./RuleConfigManager.vue?vue&type=template&id=2cf22bf2&scoped=true&"
import script from "./RuleConfigManager.vue?vue&type=script&lang=js&"
export * from "./RuleConfigManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf22bf2",
  null
  
)

export default component.exports